<template>
    <transition :name="transitionName" mode="out-in">
        <slot></slot>
    </transition>
</template>

<script>
export default {
    name: "BaseFadeTransition",
    
    props: {
        ifCrossFade: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            transitionName: "",
        }
    },

    created()
    {
        if(this.ifCrossFade)
        {
            return this.transitionName = 'fade-cross'
        }

        this.transitionName = 'fade'
    },
}
</script>

<style lang="scss" scoped>

//
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

//
.fade-cross-enter-active, .fade-cross-leave-active {
  transition: opacity 0.5s;
}
.fade-cross-enter, .fade-cross-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>